import {useContext} from 'react';

import {Grid, Typography} from '@mui/material';

import {Department} from '../types/JobPostingsTypes';

import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {safelyUseLanguageProfile} from '../../../../../utils/safelyUseLanguageProfile';

interface Props {
  departments: Department[];
}

export const DepartmentDisplay = ({departments}: Props) => {
  const lang = useContext(LanguageContext);
  return (
    <Grid>
      {departments?.map((department) => (
        <Grid key={department.resourceId}>
          <Typography variant='body1' fontWeight='bold'>
            {safelyUseLanguageProfile(lang, department.name)}
          </Typography>
          {department?.subDepartments?.map((subd) => {
            return (
              <Typography key={subd.resourceId}>&nbsp;{` • ${safelyUseLanguageProfile(lang, subd.name)}`}</Typography>
            );
          })}
        </Grid>
      ))}
    </Grid>
  );
};
